import { z } from "zod";

export const createProductFormSchema = (is_cnic, is_iemi1, is_iemi2) => {
  const baseSchema = {};

  if (is_cnic) {
    baseSchema.cnic = z
      .string()
      .min(1, "CNIC is required")
      .regex(/^\d{5}-\d{7}-\d{1}$/, "CNIC must be in format: 12345-1234567-1");
  }

  if (is_iemi1) {
    baseSchema.iemi1 = z
      .string()
      .min(1, "IMEI 1 is required")
      .regex(/^\d{15}$/, "IMEI 1 must be 15 digits");
  }

  if (is_iemi2) {
    baseSchema.iemi2 = z
      .string()
      .min(1, "IMEI 2 is required")
      .regex(/^\d{15}$/, "IMEI 2 must be 15 digits");
  }

  return z.object(baseSchema);
};

// Helper to check if form should be displayed
export const shouldShowForm = (is_cnic, is_iemi1, is_iemi2) => {
  return is_cnic || is_iemi1 || is_iemi2;
};
